export default __webpack_public_path__ + "static/media/logo.091c11db.png";